import styles from './studyNoteSection.module.scss';
import { StudyInfoCard, StudyInfoPageSection } from '../../layoutComponents/StudyInfoPageLayout';
import { ReactComponent as AddIcon } from 'assets/img/common/plus_24.svg';
import { ReactComponent as ExportIcon } from 'assets/img/common/b_export_24.svg';
import { ReactComponent as ClipboardIcon } from 'assets/img/common/il_g_clipboard_text_196.svg';
import { useGetStudyNotesConfigQuery, useGetStudyNotesQuery } from 'src/services/api/api-client/StudyNotesQuery';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { useStudyNoteFillingModal } from './useStudyNoteFillingModal';
import { StudyNoteItem } from './studyNoteItem';
import { AppButtonWithTooltip } from 'uikit/buttons/buttonWithTooltip/buttonWithTooltip';
import { useStudyNoteExport } from './useStudyNoteExport';

export const StudyNoteSection = () => {
  const { t } = useScopedTranslation('StudyInfoPage.StudyNotesSection');
  const study = useStudy();

  const studyNotesQuery = useGetStudyNotesQuery({ studyId: study!.id }, { enabled: !!study?.id });
  const studyNotesConfigQuery = useGetStudyNotesConfigQuery(
    { studyId: study!.id },
    { enabled: !!study?.id, suspense: true },
  );

  const { modal, openHandler } = useStudyNoteFillingModal();
  const { exportHandler } = useStudyNoteExport(
    studyNotesQuery.data?.map((note) => ({ result: note, config: studyNotesConfigQuery.data! })),
  );

  return (
    <>
      <StudyInfoPageSection
        title={t('Title')}
        rightHeader={
          <div className={styles.rightHeader}>
            {!!studyNotesQuery.data?.length && (
              <AppButtonWithTooltip
                variant={'icon-link'}
                colorSchema={'primary'}
                Icon={ExportIcon}
                onClick={exportHandler}
                tooltip={t('ExportButtonTooltip')}
              />
            )}
            <AppButtonWithTooltip
              variant={'icon-link'}
              colorSchema={'primary'}
              Icon={AddIcon}
              onClick={() => openHandler(null, studyNotesConfigQuery.data!)}
              disabled={studyNotesConfigQuery.isInitialLoading || !studyNotesConfigQuery.data}
              tooltip={!studyNotesConfigQuery.data ? t('NoFormConfigTooltip') : t('AddNewButtonTooltip')}
            />
          </div>
        }
        isFullHeight={true}
        variant={'flex'}
        isLoading={studyNotesQuery.isLoading || studyNotesConfigQuery.isInitialLoading}
        placeholderProps={{
          Icon: ClipboardIcon,
          text: t('Placeholder'),
          showPlaceholder: !studyNotesQuery.data?.length || !studyNotesConfigQuery.data,
        }}
      >
        <div className={styles.notesContainer}>
          {studyNotesQuery.data?.map((note) => (
            <StudyInfoCard key={note.formResultId} className={styles.noteCard}>
              <StudyNoteItem config={studyNotesConfigQuery.data!} note={note} />
            </StudyInfoCard>
          ))}
        </div>
      </StudyInfoPageSection>
      {modal}
    </>
  );
};
